import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { updateMembership } from '../services/authService';

const Subscription: React.FC = () => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);

  if (!user) {
    return (
      <div className="subscription-container">
        <div className="auth-required">
          <h2>Login Required</h2>
          <p>Please login to manage your subscription.</p>
        </div>
      </div>
    );
  }

  const handleSubscribe = async () => {
    if (!user) return;
    
    setLoading(true);
    try {
      // In a real app, this would call a payment API
      // For now, we'll just update the membership status
      updateMembership(user.id, true);
      alert('Subscription activated! Please refresh the page.');
      // Force reload to update user context
      window.location.reload();
    } catch (error: any) {
      alert(error.message || 'Error updating subscription');
    } finally {
      setLoading(false);
    }
  };

  const handleCancelSubscription = async () => {
    if (!user) return;
    
    if (!window.confirm('Are you sure you want to cancel your subscription?')) {
      return;
    }
    
    setLoading(true);
    try {
      updateMembership(user.id, false);
      alert('Subscription cancelled. Please refresh the page.');
      window.location.reload();
    } catch (error: any) {
      alert(error.message || 'Error cancelling subscription');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="subscription-container">
      <h2>Subscription Management</h2>
      
      <div className="subscription-info">
        <div className="user-info-card">
          <h3>Account Information</h3>
          <p><strong>Username:</strong> {user.username}</p>
          <p><strong>Email:</strong> {user.email}</p>
          <p><strong>Status:</strong> 
            <span className={user.isMember ? 'status-active' : 'status-inactive'}>
              {user.isMember ? ' Active Member' : ' Not a Member'}
            </span>
          </p>
        </div>

        <div className="subscription-plans">
          <h3>Membership Benefits</h3>
          <ul>
            <li>✓ Schedule events and manage bookings</li>
            <li>✓ Access to exclusive member events</li>
            <li>✓ Priority booking for popular events</li>
            <li>✓ Full event details and descriptions</li>
          </ul>

          {!user.isMember ? (
            <div className="subscribe-section">
              <h4>Become a Member</h4>
              <p>Join now to unlock all features and start scheduling events!</p>
              <button 
                onClick={handleSubscribe}
                disabled={loading}
                className="btn btn-primary btn-large"
              >
                {loading ? 'Processing...' : 'Subscribe Now'}
              </button>
              <p className="note">Note: This is a demo. In production, this would integrate with a payment system.</p>
            </div>
          ) : (
            <div className="active-subscription-section">
              <h4>Active Subscription</h4>
              <p>You have an active membership. Enjoy all the benefits!</p>
              <button 
                onClick={handleCancelSubscription}
                disabled={loading}
                className="btn btn-danger"
              >
                {loading ? 'Processing...' : 'Cancel Subscription'}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Subscription;






